<template>
  <div>
    <vs-button
      icon="add"
      style="width: 20%; border-radius: 20px"
      v-b-modal.newpmtemplate
      >New PM Template</vs-button
    >
    <b-modal
      id="newpmtemplate"
      size="lg"
      centered
      title="Please fill out the information below"
    >
      <template #modal-header-close>  <vs-button icon="close" style="border-radius: 20px" color="red" /></template>

      <template>
        <vs-col>
          <vs-radio
            v-model="typenewPM"
            vs-name="typenewPM"
            vs-value="true"
            style="justify-content: start"
          >
            Blank Template
          </vs-radio>

          <vs-radio
            v-model="typenewPM"
            vs-name="typenewPM"
            vs-value="false"
            style="justify-content: start"
          >
            Copy from an axisting Template
          </vs-radio>

          <br />

          <vs-divider />

          <br />

          <vs-input label="New Template's Name" v-model="value1" />

          <div v-if="typenewPM == 'false'">
            <vs-row class="mt-3 ml-1">
              <p class="mt-2">
                Pick a PM Template to copy form your location or even yout
                fellow manager's location
              </p>
              <vs-spacer />
              <vs-input
                class="mr-3"
                icon-after="true"
                icon="search"
                placeholder="What are you looking for?"
                v-model="value1"
              />
            </vs-row>
            <vs-collapse
              v-for="item in 7"
              :key="item"
              style="margin-bottom: -30px"
            >
              <vs-collapse-item>
                <div slot="header" class="divcard">
                  <br />
                  <vs-row>
                    <vs-icon
                      icon="folder"
                      color="dark"
                      size="30px"
                      class="ml-2"
                    ></vs-icon>
                    <p class="ml-3 mt-2">WO{{ item }}</p>
                  </vs-row>
                </div>
                <vs-card class="cardshadow ml-5" @click="this.cardcolor = red"
                  >test2</vs-card
                >
              </vs-collapse-item>
            </vs-collapse>
          </div>
        </vs-col>
      </template>
    </b-modal>
  </div>
</template>

<script>
export default {
  data() {
    return {
      typenewPM: "true",
    };
  },
};
</script>

<style></style>
